<template>
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab isshow="1"></HeadTab>
    <div class="head" id="jump0">
      <div class="head_intro">
        <div class="head_copy">
          <div class="head_tit">Деньги на карту</div>
          <div class="head_text">за 5 минут</div>
          <div class="iur">Мгновенные займы на карту любого банка Казахстана. Без справок, залога и скрытых комиссий — прозрачно и законно.</div>
        </div>
        <!-- 额度 -->
        <LoanCard :bgindex="1"></LoanCard>
      </div>
    </div>
    <!-- 中间内容 1 -->
    <div class="loq">
      <div class="njf">Почему выбирают Aicredit?</div>
      <div class="njg">Мы делаем процесс получения кредита максимально простым, быстрым и безопасным для каждого гражданина.</div>
      <div class="ijb">
        <div class="njw">
          <img class="ndq" src="/static/img/Overlay1.png" alt="" />
          <div class="vfx">Мгновенное решение</div>
          <div class="cxs">Наша интеллектуальная система обрабатывает заявки в течение 5 минут.</div>
        </div>
        <div class="njw">
          <img class="ndq" src="/static/img/Overlay2.png" alt="" />
          <div class="vfx">Безопасно и законно</div>
          <div class="cxs">Работаем строго по лицензии Управление региональных представителей в г. Нур-Султан Агентства Республики Казахстан по регулированию и развитию финансовых рынков. Ваши персональные данные защишены передовыми алгоритмами шифрования.</div>
        </div>
        <div class="njw">
          <img class="ndq" src="/static/img/Overlay3.png" alt="" />
          <div class="vfx">На любую карту</div>
          <div class="cxs">Перевод средств осуществляется моментально на карту любого банка РК.</div>
        </div>
      </div>
    </div>
    <!-- 中间内容 2 -->
    <div class="urt">
        <div class="steps_panel">
          <div class="steps_title">Как получить заем за 3 шага</div>
          <div class="steps_list">
            <div class="step_item">
              <div class="step_badge">1</div>
              <div class="step_body">
                <div class="step_name">Выберите сумму</div>
                <div class="step_desc">Укажите необходимую сумму в приведенном выше калькуляторе.</div>
              </div>
            </div>
            <div class="step_item">
              <div class="step_badge">2</div>
              <div class="step_body">
                <div class="step_name">Заполните анкету</div>
                <div class="step_desc">Введите ИИН, контактные данные и номер карты для получения денег.</div>
              </div>
            </div>
            <div class="step_item step_item-last">
              <div class="step_badge">3</div>
              <div class="step_body">
                <div class="step_name">Получите деньги</div>
                <div class="step_desc">После SMS-подтверждения деньги мгновенно поступят на ваш счет.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="steps_visual">
          <img class="steps_image" src="/static/img/Container10.png" alt="Как получить заем" />
          <div class="steps_review">
            <div class="steps_review-text">Деньги пришли через 3 минуты после заявки. Очень удобно!</div>
            <div class="steps_review-author">-Арина К.</div>
          </div>
        </div>
    </div>
    <!-- 中间内容 3 -->
    <div class="olq">
        <div class="poi">Кто может получить заем?</div>
        <div class="vfz">Мы лояльны к нашим клиентам и предъявляем минимальные требования.</div>
        <div class="eligibility">
          <div class="eligibility_content">
            <div class="eligibility_grid">
              <div class="eligibility_card">
                <img class="eligibility_icon" src="/static/img/Container.png" alt="" />
                <div class="eligibility_text">Гражданство РК</div>
              </div>
              <div class="eligibility_card">
                <img class="eligibility_icon" src="/static/img/Container.png" alt="" />
                <div class="eligibility_text">Возраст от 18 до 65 лет</div>
              </div>
              <div class="eligibility_card">
                <img class="eligibility_icon" src="/static/img/Container.png" alt="" />
                <div class="eligibility_text">Наличие ИИН</div>
              </div>
              <div class="eligibility_card">
                <img class="eligibility_icon" src="/static/img/Container.png" alt="" />
                <div class="eligibility_text">Личная банковская карта и мобильный номер</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>
<script>
  import BomTab from '@/components/BomTab.vue'
  import HeadTab from '@/components/HeadTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "home",
    data() {
      return {};
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {

    },
  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .head{
    background-image: url(/static/img/Group_01.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0.54rem 1.58rem 0.9rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .head_intro{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .head_copy{
    margin-bottom: 0.21rem;
  }
  .head_tit{
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.29rem;
    margin-bottom: 0.1rem;
  }
  .head_text{
    color: #FF5836;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.29rem;
    margin-bottom: 0.08rem;
  }
  .iur{
    width: 3.35rem;
    color: #666666;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.13rem;
    line-height: 0.19rem;
    text-align: left;
  }
  .loq{
    background: #FFF8F6;
    padding: 0.83rem 0;
  }
  .njf{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.25rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.06rem;
  }
  .njg{
    width: 3.49rem;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.09rem;
    color: #5B403B;
    line-height: 0.15rem;
    text-align: center;
    font-style: normal;
    margin: 0 auto 0.17rem;
  }
  .ijb{
    padding: 0 1.58rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .njw{
    width: 1.67rem;
    height: 1.4rem;
    background: rgba(255,255,255,0.7);
    box-shadow: 0rem 0.01rem 0.01rem 0rem rgba(0,0,0,0.05);
    border-radius: 0.08rem;
    padding: 0.26rem;
  }
  .ndq{
    width: 0.33rem;
    height: 0.33rem;
    margin-bottom: 0.08rem;
  }
  .vfx{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.13rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .cxs{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #5B403B;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
  }
  .urt{
    background: #FFFFFF;
    padding: 0.83rem 1.58rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.33rem;
  }
  .steps_panel{
    flex: 1;
  }
  .steps_title{
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.19rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.25rem;
  }
  .steps_list{
    position: relative;
  }
  .steps_list::before{
    content: "";
    position: absolute;
    top: 0.14rem;
    bottom: -0.01rem;
    left: 0.12rem;
    width: 0.01rem;
    background: #ddb4af;
  }
  .step_item{
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 0.13rem;
    margin-bottom: 0.25rem;
    z-index: 1;
  }
  .step_item-last{
    margin-bottom: 0;
  }
  .step_badge{
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 50%;
    background: #b8382c;
    box-shadow: 0rem 0.03rem 0.05rem 0rem rgba(182,36,4,0.2);
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    line-height: 0.25rem;
    text-align: center;
  }
  .step_body{
    flex: 1;
  }
  .step_name{
    font-family: Montserrat, Montserrat;
    font-weight: 700;
    font-size: 0.1rem;
    color: #394150;
    margin-bottom: 0.04rem;
  }
  .step_desc{
    width: 2.33rem;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 0.08rem;
    color: #5B403B;
    line-height: 0.13rem;
  }
  .steps_visual{
    width: 3.25rem;
    height: 2.92rem;
    position: relative;
    flex-shrink: 0;
  }
  .steps_image{
    width: 100%;
  }
  .steps_review{
    width: 0.75rem;
    position: absolute;
    left: -0.01rem;
    bottom: -0.01rem;
    background: #e58b8b;
    border-radius: 0.08rem;
    padding: 0.13rem;
    box-shadow: 0rem 0.08rem 0.18rem rgba(182, 84, 84, 0.22);
  }
  .steps_review-text{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 0.07rem;
    color: #742414;
    line-height: 0.1rem;
    margin-bottom: 0.04rem;
  }
  .steps_review-author{
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 0.06rem;
    color: #742414;
    line-height: 0.08rem;
  }
  .olq{
    padding: 0.73rem 1.58rem 0.83rem;
    background: #FFF8F6;
  }
  .poi{
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.19rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .vfz{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #5B403B;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.25rem;
  }
  .eligibility{
    display: flex;
    justify-content: flex-end;
  }
  .eligibility_content{
    width: 100%;
  }
  .eligibility_grid{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.13rem;
  }
  .eligibility_card{
    min-height: 0.42rem;
    background: #FFE9E5;
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    padding: 0 0.21rem;
    box-sizing: border-box;
  }
  .eligibility_icon{
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.08rem;
  }
  .eligibility_text{
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    color: #333333;
  }

  @media screen and (max-width: 1200px) {
    .head,
    .loq,
    .urt,
    .olq {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .head {
      gap: 0.3rem;
    }
    .head_tit,
    .head_text {
      font-size: 0.3rem;
      line-height: 0.38rem;
    }
    .iur {
      width: 3.4rem;
    }
    .steps_panel,
    .steps_visual {
      width: 100%;
    }
    .step_desc {
      width: auto;
      max-width: 3.2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .head {
      padding-top: 0.42rem;
      flex-direction: column;
      align-items: flex-start;
    }
    .head_intro,
    .iur {
      width: 100%;
    }
    .head_tit,
    .head_text {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
    .loq,
    .urt,
    .olq {
      padding-left: 0.2rem;
      padding-right: 0.2rem;
    }
    .ijb,
    .urt,
    .eligibility {
      flex-direction: column;
      align-items: stretch;
    }
    .ijb,
    .urt,
    .eligibility {
      gap: 0.2rem;
    }
    .njw,
    .steps_visual,
    .steps_panel,
    .eligibility_content {
      width: 100%;
    }
    .eligibility_grid {
      grid-template-columns: 1fr;
      gap: 0.14rem;
    }
    .eligibility_card {
      min-height: 0.64rem;
      padding: 0.16rem 0.18rem;
    }
    .steps_title,
    .njf {
      font-size: 0.22rem;
      line-height: 0.3rem;
    }
    .steps_review {
      left: 0.12rem;
      bottom: 0.12rem;
    }
    .step_desc,
    .njg,
    .cxs {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue